import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-eye-off',
  imports: [],
  standalone: true,
  templateUrl: './icon-eye-off.component.html',
  styleUrl: './icon-eye-off.component.css',
})
export class IconEyeOffComponent {

}
